<div class="tabela-atividades">
    <app-card-content [border]="false" headingLevel="h1" [icon]="'pi pi-table'" [title]="'Atividades'" [subtitle]="'Atividades de comissões e situação de execução'">
        <div card-header class="tabela-atividades-acoes">
            <p-button
                icon="pi pi-filter"
                [outlined]="true"
                [pTooltip]="filtrosVisiveis() ? 'Ocultar filtros' : 'Mostrar filtros'"
                tooltipPosition="bottom"
                [ariaLabel]="filtrosVisiveis() ? 'Ocultar filtros' : 'Mostrar filtros'"
                (click)="alternarFiltros.emit()"
                [style]="{ height: '2.2rem', width: '2.2rem', padding: '0' }"
            ></p-button>

            <p-button
                icon="pi pi-objects-column"
                [outlined]="true"
                pTooltip="Colunas visíveis"
                tooltipPosition="bottom"
                ariaLabel="Colunas visíveis"
                (click)="op.toggle($event)"
                [style]="{ height: '2.2rem', width: '2.2rem', padding: '0' }"
            ></p-button>
            <p-popover #op [appendTo]="'body'">
                <ng-template #content>
                    <div class="flex flex-col gap-2 p-2 min-w-[200px] max-w-[280px]">
                        <div class="flex items-center justify-between pb-2 border-b border-surface-200 dark:border-surface-700">
                            <span class="font-semibold text-sm">Colunas Visíveis</span>
                            <button class="text-xs text-primary hover:underline cursor-pointer bg-transparent border-none p-0" (click)="toggleTodasColunas()">
                                {{ todasSelecionadas() ? 'Desmarcar Todos' : 'Marcar Todos' }}
                            </button>
                        </div>
                        <div class="flex flex-col gap-1 max-h-[250px] overflow-y-auto pr-1">
                            @for (opcao of opcoesColunas; track opcao.value) {
                                <label class="flex items-center gap-2 p-1.5 hover:bg-surface-50 dark:hover:bg-surface-800 rounded cursor-pointer select-none">
                                    <input type="checkbox" [checked]="colunasSelecionadas.includes(opcao.value)" (change)="toggleColuna(opcao.value)" class="rounded border-surface-300 text-primary focus:ring-primary w-4 h-4 cursor-pointer" />
                                    <span class="text-sm text-surface-700 dark:text-surface-300">{{ opcao.label }}</span>
                                </label>
                            }
                        </div>
                    </div>
                </ng-template>
            </p-popover>

            <app-botao-acoes label="Opções" [iconPos]="EInconPos.LEFT" [items]="itensOpcoesMenu()" [iconColumns]="3"></app-botao-acoes>
        </div>

        <div class="grid-indicadores">
            <app-kpi-comissoes
                icone="pi pi-briefcase"
                [tom]="ETomKpi.INFO"
                [valor]="valorIndicador(totalAtividades)"
                rotulo="Total de atividades"
                legenda="Todas as situações"
            />

            <!-- Pendentes e resolvidas vêm do agregado server-side, no mesmo escopo do total: os três
                 cartões falam do conjunto inteiro. Enquanto o resumo não chega mostram "–", nunca um
                 número da página. -->
            <app-kpi-comissoes
                icone="pi pi-hourglass"
                [tom]="ETomKpi.ATENCAO"
                [valor]="valorIndicador(totalPendentes)"
                rotulo="Atividades pendentes"
                [legenda]="legendaFatia(totalPendentes)"
            />

            <app-kpi-comissoes
                icone="pi pi-check-circle"
                [tom]="ETomKpi.SUCESSO"
                [valor]="valorIndicador(totalResolvidas)"
                rotulo="Atividades resolvidas"
                [legenda]="legendaFatia(totalResolvidas)"
            />
        </div>

        <app-custom-table
            [data]="dataMapped"
            [metadata]="metadataTabela"
            [first]="first()"
            [rows]="rows()"
            [totalRecords]="totalRegistros() ?? 0"
            [rowsPerPageOptions]="opcoesLinhasPorPagina"
            [loading]="carregando()"
            [rowClickable]="true"
            [initialViewMode]="'table'"
            [cardColumns]="2"
            [useCustomCard]="true"
            [minWidth]="'916px'"
            (onPageChange)="onPaginaAlterada($event)"
            (onRowClick)="handleRowClick($event)"
        >
            <!-- Cada coluna empilha as linhas do próprio assunto: a de cima identifica, as de baixo
                 detalham. O nome do dado acompanha o valor — visível ("até 02/07/2026", "Resp.: …"),
                 num span só-de-leitor + tooltip (protocolo, reunião) — e é isso que permite empilhar a
                 linha em blocos no telefone sem o cabeçalho da coluna. Ver o .scss. -->
            <ng-template pTemplate="cell" let-rowData="rowData" let-column="column">
                @switch (column.key) {
                    <!-- Sem rótulo visível: o selo diz "protocolo" pela forma, e o prefixo "Reunião"
                         nomeia o segundo código para ele não ser confundido com o da atividade. -->
                    @case ('codigo') {
                        <!-- A situação anda junto do código, na mesma linha: relógio para pendente,
                             visto para resolvida. Numa coluna de duas palavras que se repetem linha
                             após linha, a forma se lê de relance e a palavra não. O nome por extenso
                             segue no tooltip e no `aria-label` — nada depende só do desenho. -->
                        <span class="atv-linha atv-linha--forte atv-maquina">
                            #{{ rowData.codigo }}
                            <i
                                class="atv-pip"
                                [ngClass]="[obterIconeStatus(rowData.status.value), 'atv-pip--' + (rowData.status.severity || 'secondary')]"
                                role="img"
                                [attr.aria-label]="'Situação: ' + rowData.status.value"
                                [pTooltip]="'Situação: ' + rowData.status.value"
                                tooltipPosition="top"
                            ></i>
                        </span>
                        @if (exibeProtocolo(rowData)) {
                            <span class="atv-linha">
                                <span class="atv-chip atv-chip--protocolo atv-maquina" pTooltip="Protocolo" tooltipPosition="top"><span class="sr-only">Protocolo </span>{{ rowData.protocolo }}</span>
                            </span>
                        }
                        @if (exibeReuniao(rowData)) {
                            <span class="atv-linha atv-secundaria" pTooltip="Código da reunião de origem" tooltipPosition="top">
                                Reunião <span class="atv-maquina">{{ rowData.codigoReuniao }}</span>
                            </span>
                        }
                    }
                    <!-- O número identifica; a descrição detalha em duas linhas e o texto inteiro fica
                         no tooltip, para a coluna não crescer com o registro mais falante. -->
                    @case ('numeroAtividade') {
                        <span class="atv-linha atv-linha--forte atv-maquina"><span class="sr-only">Atividade nº </span>Nº {{ rowData.numeroAtividade }}</span>
                        @if (exibeDescricao(rowData)) {
                            <span class="atv-linha atv-descricao" [title]="rowData.descricao">{{ rowData.descricao }}</span>
                        }
                    }
                    <!-- Início em cima, término embaixo num corpo menor — mesmo desenho de "Data e
                         Horário" em Acompanhamento. Sem término, a atividade segue em aberto. -->
                    @case ('dataInicio') {
                        <span class="atv-linha atv-linha--forte atv-maquina"><span class="sr-only">Início </span>{{ rowData.dataInicio }}</span>
                        @if (prazoNoMesmoDia(rowData)) {
                            <span class="atv-linha atv-secundaria">no mesmo dia</span>
                        } @else if (exibePrazoFim(rowData)) {
                            <span class="atv-linha atv-secundaria atv-maquina">até {{ rowData.dataFim }}</span>
                        } @else {
                            <span class="atv-linha atv-vazio">em aberto</span>
                        }
                    }
                    @case ('comissaoNucleo') {
                        <span class="atv-linha atv-linha--titulo">
                            <span class="atv-titulo-nome" [title]="rowData.comissaoNucleo">{{ rowData.comissaoNucleo }}</span>
                        </span>
                    }
                    <!-- Retrato e nome lado a lado, no mesmo desenho da coluna Assistente de
                         Acompanhamento. Sem foto — o caso comum na base — o círculo traz as
                         iniciais: sem ele as linhas com e sem retrato desalinhariam na varredura
                         vertical. O círculo é enfeite (`aria-hidden`), quem nomeia é o texto. -->
                    @case ('responsavel') {
                        @if (exibeResponsavel(rowData)) {
                            <span class="atv-linha atv-responsavel-linha">
                                @if (fotoResponsavel(rowData); as foto) {
                                    <img [src]="foto" alt="" class="atv-foto" aria-hidden="true" />
                                } @else {
                                    <span class="atv-foto atv-foto--iniciais" aria-hidden="true">{{ iniciaisResponsavel(rowData) }}</span>
                                }
                                <span class="atv-responsavel font-medium text-sm" [title]="rowData.responsavel">{{ rowData.responsavel }}</span>
                            </span>
                        } @else {
                            <span class="atv-linha atv-vazio">Não informado</span>
                        }
                    }
                }
            </ng-template>

            <!-- O botão de recolher a linha desdobrada não vive mais aqui: é do `app-custom-table`,
                 que o desenha na própria célula expandida. Assim ele existe em toda tabela com card
                 próprio, e não só nas que se lembraram de implementá-lo. -->
            <ng-template pTemplate="card" let-rowData let-selected="selected">
                <app-card-container [selected]="selected || isRowSelected(rowData)" [hoverEfect]="true" (dblclick)="onVisualizar(rowData.source)" class="atividade-card-item cursor-pointer block h-full">
                    <div class="atividade-card-header">
                        <div class="atividade-card-title-row">
                            <div class="atividade-card-status-text" [ngClass]="'status-' + rowData.status.severity">
                                <span>{{ rowData.status.value }}</span>
                            </div>
                            <h3 class="atividade-card-title" [title]="rowData.comissaoNucleo">
                                {{ (rowData.comissaoNucleo ?? '').length > 70 ? (rowData.comissaoNucleo | slice: 0 : 70) + '...' : (rowData.comissaoNucleo ?? '') }}
                            </h3>
                        </div>
                        <div class="atividade-card-subtitle">
                            Nº Atividade: <span>{{ rowData.numeroAtividade }}</span> | Cód: <span>{{ rowData.codigo }}</span> | Reunião: <span>{{ rowData.codigoReuniao }}</span>
                        </div>
                    </div>

                    <div class="atividade-card-body">
                        <!-- Period -->
                        <div class="atividade-card-row">
                            <i class="pi pi-calendar"></i>
                            <span class="atividade-card-field-value">
                                Período: <span>{{ rowData.dataInicio }} • {{ rowData.dataFim }}</span>
                            </span>
                        </div>

                        <!-- Responsável: o retrato vem no círculo miúdo, ao lado do nome. Aqui a
                             linha é rotulada e cabe numa fileira do cartão, então 22px — os 45px da
                             coluna da tabela desequilibrariam as demais linhas. Sem foto entram as
                             iniciais no mesmo círculo, como na tabela. É enfeite: quem nomeia é o
                             texto, então fica `aria-hidden`. -->
                        <div class="atividade-card-row">
                            <i class="pi pi-user"></i>
                            <span class="atividade-card-field-value atividade-card-responsavel">
                                Responsável:
                                @if (exibeResponsavel(rowData)) {
                                    @if (fotoResponsavel(rowData); as foto) {
                                        <img [src]="foto" alt="" class="atv-foto atv-foto--miuda" aria-hidden="true" />
                                    } @else {
                                        <span class="atv-foto atv-foto--miuda atv-foto--iniciais" aria-hidden="true">{{ iniciaisResponsavel(rowData) }}</span>
                                    }
                                }
                                <span>{{ rowData.responsavel }}</span>
                            </span>
                        </div>

                        <!-- Descrição -->
                        <div class="atividade-card-row description-row">
                            <i class="pi pi-file"></i>
                            <span class="atividade-card-field-value text-wrap">
                                Descrição: <span class="description-text">{{ rowData.descricao }}</span>
                            </span>
                        </div>
                    </div>
                </app-card-container>
            </ng-template>
        </app-custom-table>
    </app-card-content>
</div>
